import { tv } from "../../variants/tv.js";
const reviewBadgeVariants = tv({
    slots: {
        badgeSlot: 'bg-customer-8 inline-flex items-center justify-center antialiased transition',
        textSlot: 'text-customer-1 font-bold text-center'
    },
    variants: {
        size: {
            xs: {
                badgeSlot: 'w-7 h-4 pl-[1px] rounded-tl-md rounded-bl-md rounded-tr-sm rounded-br-xsm',
                textSlot: 'text-body3'
            },
            sm: {
                badgeSlot: 'w-8 h-5 pl-[1px] rounded-tl-lg rounded-bl-lg rounded-tr-md rounded-br-xsm',
                textSlot: 'text-heading6'
            },
            md: {
                badgeSlot: 'w-10 h-6 pl-[2px] rounded-tl-lg rounded-bl-lg rounded-tr-md rounded-br-sm',
                textSlot: 'text-heading5'
            },
            lg: {
                badgeSlot: 'w-13 h-8 pl-[2px] rounded-tl-xl rounded-bl-xl rounded-tr-lg rounded-br-sm',
                textSlot: 'text-heading4'
            }
        }
    },
    defaultVariants: {
        size: 'md'
    }
});
const reviewBadgeSizes = Object.keys(reviewBadgeVariants.variants.size);
export { reviewBadgeSizes, reviewBadgeVariants };
